const routes = {
  getCustomerOrders: 'reports/customers/orders',
  getOrderReportByCustomer: 'reports/customers/',
};

export default routes